module.exports = __webpack_public_path__ + "img/invitation_mode_1.62460206.png";